import urls from "../../../global/constants/UrlConstants";
import {
  getCallParams,
  getFileCallParams,
  makeCall,
} from "../../../utils/service";
import type { StoredProductItem } from "./ProductManagement";

export interface GetProductSectionsResponse {
  items?: StoredProductItem[];
}

export const getProductSections = async (): Promise<any> => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.bannersApi, callParams);
    return response;
  } catch {
    return [];
  }
};

export const saveProductSections = async (formData: any) => {
  try {
    const callParams = await getFileCallParams(formData);
    const response = await makeCall(urls.bannersApi, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteBannerSection = async (id: number) => {
  const url = `${urls.bannersApi}/${id}`;
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
